import React, { useState } from 'react';
import { MobileHomeHeader } from '../MobileHomeHeader';
import { Header } from '../layout/Header';
import { LocationModal } from '../modals/LocationModal';
type LocationValue = {
  name: string;
  address?: string;
  type?: string;
} | null;
export function NowPageHeader() {
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<LocationValue>(null);
  return <>
      <div className="hidden md:block" data-id="element-4170" data-mp="2iwwlwf9bb09g">
        <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} showAnnouncement data-id="element-4171" data-mp="2nxka6t65p2zz" />
      </div>
      <div className="md:hidden" data-id="element-4172" data-mp="2wsi4a3l1ilsw">
        <MobileHomeHeader selectedLocation={selectedLocation} onOpenLocationModal={() => setLocationModalOpen(true)} alwaysWhiteBackground data-id="element-4173" data-mp="31q0ia8dwzr7r" />
      </div>
      <LocationModal isOpen={locationModalOpen} onClose={() => setLocationModalOpen(false)} onSelectLocation={location => {
      setSelectedLocation(location);
      setLocationModalOpen(false);
    }} data-id="element-4174" data-mp="237dpnmcu38dw" />
    </>;
}